import { useState } from "react";
import { Loader2 } from "lucide-react";
import { JourneyField as Field, JourneySelect as Select } from "../controls";
import { LANGUAGES } from "@/lib/languages";

const LANGUAGE_OPTIONS = LANGUAGES.map((language) => [
  language.code,
  language.nativeName !== language.label ? `${language.label} — ${language.nativeName}` : language.label,
]);

export const LanguageStep = ({ answers, update, onSaveJourney }) => {
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    setSaving(true);
    const ok = await onSaveJourney({ contact_email: email.trim(), contact_mobile: mobile.trim() });
    setSaving(false);
    if (ok) setSaved(true);
  };

  return (
    <div>
      <h2 className="font-display text-3xl font-bold tracking-tight text-ink">Choose your language</h2>
      <p className="mt-2 text-sm leading-6 text-slatey">Your choice stays with you throughout your journey. More languages will be added over time.</p>
      <div className="mt-6 max-w-xl">
        <Field label="Language">
          <Select value={answers.language} onChange={(v) => update("language", v)} testId="journey-language" placeholder="Select a language" options={LANGUAGE_OPTIONS} />
        </Field>
      </div>

      <div className="mt-8 rounded-3xl border border-slate-200 bg-surface p-5" data-testid="save-journey-panel">
        <h3 className="font-display text-xl font-bold text-ink">Save your journey</h3>
        <p className="mt-1 text-sm font-semibold text-slatey">So you can pick up where you left off.</p>
        <p className="mt-3 text-sm leading-6 text-slatey">Enter your email address or mobile number and we’ll save your progress.</p>
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <input value={email} onChange={(event) => setEmail(event.target.value)} data-testid="journey-save-email" type="email" placeholder="Email address"
            className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-[15px] outline-none transition-colors focus:border-cobalt focus:ring-2 focus:ring-cobalt/15" />
          <input value={mobile} onChange={(event) => setMobile(event.target.value)} data-testid="journey-save-mobile" type="tel" placeholder="Mobile number"
            className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-[15px] outline-none transition-colors focus:border-cobalt focus:ring-2 focus:ring-cobalt/15" />
        </div>
        <div className="mt-4 flex flex-wrap items-center gap-3">
          <button onClick={save} disabled={saving || saved || (!email.trim() && !mobile.trim())} data-testid="journey-save-button"
            className="inline-flex items-center gap-2 rounded-full bg-cobalt px-5 py-3 text-sm font-bold text-white disabled:opacity-50">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />} {saved ? "Journey saved" : "Save my journey"}
          </button>
          <span className="text-xs text-slatey">Optional — you can continue without saving.</span>
        </div>
      </div>
    </div>
  );
};
